// eslint-disable-next-line import/no-cycle
import actions from './actions';

export default {
  namespaced: true,
  actions,
};
